import { defineComponent, inject, onMounted, onUnmounted } from "vue";
import SelectedFilters from "./SelectedFilters.class";
import { FilterProviderKey } from "@/models/FilterProviderKey";
import { IFilterProvider } from "@/interfaces/filter-providers/IFilterProvider";

export default defineComponent({
	setup: () => {

		const filterProvider: IFilterProvider | undefined = inject(FilterProviderKey.FILTER_PROVIDER);
		if (filterProvider == null) {
			throw new Error(`${FilterProviderKey.FILTER_PROVIDER} was not provided for SelectedFilters`);
		}

		const component = new SelectedFilters(filterProvider);

		onMounted(component.onMounted.bind(component));
		onUnmounted(component.onUnmounted.bind(component));

		return {
			tags: component.tags,
			filtersApplied: component.filtersApplied,
			removableFiltersCount: component.removableFiltersCount,
			filterTagContainerRef: component.tagContainer.tagContainerRef,
			shouldDisplayShowMore: component.tagContainer.shouldDisplayShowMore,
			shouldDisplayShowLess: component.tagContainer.shouldDisplayShowLess,
			showMore: component.tagContainer.showMore.bind(component),
			showLess: component.tagContainer.showLess.bind(component),
			clearAll: component.clearAll.bind(component)
		}
	}
});
